$(document).ready(function() {
    const header = $('.site-header');
    const burgerMenu = $('.burger-menu');
    const menuWrap = $('.site-header__right');
    const mobileBtn = '.header-menu__listItem.menu-item-has-children';
    const mobileSubmenu = '.mega-menu__dropDown, .header-menu__sub-list';

    $(burgerMenu).click(function() {
        $(header).toggleClass('open-menu');
        $(menuWrap).fadeToggle(200);
    });

    $(mobileBtn).click(function(event) {
        if (event.target !== this && !$(event.target).hasClass('header-menu__listItemIcon')) return;
        $(this)
            .toggleClass('header-menu__listItem--open')
            .find(mobileSubmenu)
            .slideToggle(function() {
                $(this).parent();
            });
    });

    $(window).resize(function() {
        if (window.innerWidth > 1101) {
            $(header).removeClass('open-menu');
            $(menuWrap).removeAttr('style');
            $(mobileBtn).removeClass('header-menu__listItem--open');
            $(mobileSubmenu).removeAttr('style');
        }
    });
});
